**Deprecated:** This field is always `Company` and can be safely removed.
